import React, { useState, useEffect } from 'react';
import { MapPin, Search, Filter, DollarSign } from 'lucide-react';
import { api } from '../services/api';

const Classifieds = () => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchClassifieds = async () => {
            try {
                const data = await api.getListings('classified');
                setItems(data);
            } catch (err) {
                setError('Failed to load classifieds');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchClassifieds();
    }, []);

    if (loading) return <div className="p-4 text-center">Loading classifieds...</div>;
    if (error) return <div className="p-4 text-center text-red-500">{error}</div>;

    return (
        <div className="pb-20 bg-gray-50 min-h-screen">
            {/* Header */}
            <header className="bg-white p-4 sticky top-0 z-10 shadow-sm">
                <div className="flex items-center justify-between mb-4">
                    <div>
                        <h1 className="text-2xl font-bold text-gray-900">Classifieds</h1>
                        <div className="flex items-center text-gray-500 text-sm mt-1">
                            <MapPin size={14} className="mr-1" />
                            <span>San Francisco, CA</span>
                        </div>
                    </div>
                    <button className="p-2 bg-gray-100 rounded-full">
                        <Filter size={20} className="text-gray-600" />
                    </button>
                </div>

                {/* Search Bar */}
                <div className="relative">
                    <Search size={20} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                    <input
                        type="text"
                        placeholder="Search furniture, electronics, jobs..."
                        className="w-full pl-10 pr-4 py-3 bg-gray-100 rounded-xl outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>
            </header>

            {/* Classifieds List */}
            <div className="p-4 grid grid-cols-2 gap-4">
                {items.map(item => (
                    <div key={item.id} className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100">
                        <div className="relative h-32">
                            <img
                                src={JSON.parse(item.image_urls)[0] || 'https://images.unsplash.com/photo-1556228453-efd6c1ff04f6'}
                                alt={item.title}
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute bottom-2 left-2 bg-black/70 backdrop-blur-sm px-2 py-1 rounded-lg text-xs font-bold text-white flex items-center">
                                <DollarSign size={10} className="mr-0.5" />
                                {item.price || 'N/A'}
                            </div>
                        </div>
                        <div className="p-3">
                            <h3 className="text-sm font-bold text-gray-900 mb-1 line-clamp-1">{item.title}</h3>
                            <p className="text-xs text-gray-500 mb-2 line-clamp-2">{item.description}</p>

                            <div className="flex items-center justify-between">
                                <div className="flex items-center text-gray-400 text-xs">
                                    <MapPin size={10} className="mr-1" />
                                    <span>{item.city}</span>
                                </div>
                                <span className="text-xs text-gray-400">{new Date(item.created_at).toLocaleDateString()}</span>
                            </div>
                        </div>
                    </div>
                ))}
                {items.length === 0 && (
                    <div className="col-span-2 text-center text-gray-500 py-10">
                        No classifieds found.
                    </div>
                )}
            </div>
        </div>
    );
};

export default Classifieds;
